import { createContext } from 'react'

export const config = {
  onClick: () => {}
}

export const MobileNavContext = createContext(config)



// WEBPACK FOOTER //
// ./src/layouts/DefaultLayout/components/NavBar/contexts/mobile-nav.js